import Alert from '@risk-smart/themed-cloudscape-components/alert';
import Box from '@risk-smart/themed-cloudscape-components/box';
import type { FC } from 'react';

import { humanFileSize } from './fileUtils';
import type { FileItemProps } from './types';

const FileItem: FC<FileItemProps> = ({
  fileId,
  onRemove,
  fileName,
  fileSize,
  file,
  error,
  disabled,
  downloadFile,
}) => {
  return (
    <Box
      data-testid={'file-list-file-item'}
      margin={{ vertical: 'xs' }}
      key={fileId || file?.name}
    >
      <Alert
        type={error ? 'error' : 'success'}
        onDismiss={onRemove}
        dismissible={!disabled}
        // Consumers use react-i18next rather than Cloudscape's I18nProvider, so
        // the dismiss button's accessible name must be supplied directly.
        i18nStrings={{ dismissAriaLabel: `Remove ${fileName}` }}
      >
        <div
          data-testid={'file-download'}
          onClick={async () => {
            downloadFile({ fileId, fileName, file });
          }}
        >
          <span data-testid={'file-name'}>{fileName}</span>
          <br />
          <Box variant={'small'}>{humanFileSize(fileSize)}</Box>
        </div>
      </Alert>
    </Box>
  );
};

export default FileItem;
